import React, {useContext, useEffect, useState} from "react";
import {IAssistantContext} from "../dependencies/interfaces/IAssistantContext";
import AppContext, {IAppV2Context} from "../../../componentsApp/context/AppContext";
import Spaces from "../../../sharedComponents/components/Spaces";
import {ButtonBack} from "../../../sharedComponents/components/Buttons/ButtonBack";

export default (props: IAssistantContext) => {
  
  const appContextV2: IAppV2Context = useContext(AppContext) as IAppV2Context;
  
  return (<section>
    
    <Spaces n={0}/>
    
    <div className={"assistant--v2-container--no-flex"}>
      <div className={"space-light"}>
        <ButtonBack back={() => props.wizard.previousStep()}/>
      </div>
    </div>
    
    <div className={"assistant--v2-title"}>
      Quand débute la prise de poste ?
    </div>
    
    <Spaces n={1}/>
    
    <div className={"assistant--v2-container"}>
      
      <button className={"btn-assistant-main"}
              onClick={() => {
                props.updateForm()({target: {type: "custom", name: "asSoonAsPossible", value: true}});
                props.updateForm()({target: {type: "custom", name: "permanent", value: false}});
                props.wizard.goToStep('duration');
              }}>
        Dès que possible
      </button>
      
      <button className={"btn-assistant-main"}
              onClick={() => {
                props.updateForm()({target: {type: "custom", name: "asSoonAsPossible", value: false}});
                props.updateForm()({target: {type: "custom", name: "permanent", value: false}});
                props.wizard.goToStep('dateCustom');
              }}>
        À une date spécifique
      </button>
  
      <button className={"btn-assistant-main"}
              onClick={() => {
                props.updateForm()({target: {type: "custom", name: "asSoonAsPossible", value: false}});
                props.updateForm()({target: {type: "custom", name: "permanent", value: true}});
  
                const contractsWithoutDurationStep: string[] = ["CDI"];
                if(contractsWithoutDurationStep.includes(props.form.contract)) {
                  props.wizard.goToStep("salaryBy");
                } else {
                  props.wizard.goToStep('duration');
                }
                
              }}>
        Recrutement permanent
      </button>
    
    </div>
    
    <Spaces n={1}/>
    
    <div className={"text--center text--grey assistant--v2-container--no-flex"}>
    </div>
  
  </section>);
}